<template>
  <div class="show_plaque" :class="size">
    <div class="p-right tw-flex tw-justify-center tw-items-center">
      {{ car?.car_number_base }}
    </div>
    <div class="p-center tw-flex tw-justify-center tw-items-center">
      <div>
        <span>{{ car?.car_number_three_digits }}</span>
        <span class="p-letter">{{ car?.car_number_letter }}</span>
        <span>{{ car?.car_number_two_digits }}</span>
      </div>
    </div>
    <div class="p-left ltr">
      <img src="/img/icons/iran_flag.jpg" class="tw-w-[15px] tw-mb-[2px]"/>
      <span class="d-block text-left ltr tw-mb-[2px]" style="line-height: 9px">I.R</span>
      <span class="d-block text-left ltr text-regular" style="line-height: 9px">IRAN</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LicensePlate',
  props: ['car', 'size'],
}
</script>
